import React, { Fragment } from "react"

import Modal from "react-bootstrap/lib/Modal"
import ServiceConfigurator from "./ServiceConfigurator"
import AddServiceButton from "./AddServiceButton"
import HumanizedPrice from "../../ServiceRow/HumanizedPrice"
import ShowMoreText from "react-show-more-text"

function getInitialState(props) {
  let chosenConfigurations = {}
  props.serviceSectionPartConfigs.map((configuration) => {
    chosenConfigurations[configuration.id] = { partIds: [] }
  })

  return {
    quantity: 1,
    chosenConfigurations: chosenConfigurations,
    specialInstruction: "",
  }
}

export default class AddServiceModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = getInitialState(props)
  }

  componentWillReceiveProps(nextProps) {
    this.setState(getInitialState(nextProps))
  }

  /*static getDerivedStateFromProps(props, state) {
        return getInitialState(props);
    }*/

  addToCart = () => {
    let alertTime
    let chosenParts = []

    if (
      this.props.service.launch_available &&
      !this.props.service.dinner_available
    ) {
      alertTime = I18n.t("service_ordering.only_lunch_alert")
    } else if (
      !this.props.service.launch_available &&
      this.props.service.dinner_available
    ) {
      alertTime = I18n.t("service_ordering.only_dinner_alert")
    }

    if (alertTime && confirm(alertTime) !== true) {
      return false
    }

    this.props.serviceSectionPartConfigs.map((configuration) => {
      configuration.service_part_options.map((part) => {
        if (
          this.state.chosenConfigurations[configuration.id].partIds.indexOf(
            part.id
          ) !== -1
        ) {
          chosenParts.push({
            id: part.id,
            name: part.name,
            price: part.price_cents,
          })
        }
      })
    })

    this.props.addToCart(
      chosenParts,
      this.state.quantity,
      this.getSpecialInstructions()
    )
    this.props.onHide()
  }

  decreaseQuantity = (event) => {
    event.preventDefault()

    if (this.state.quantity > 1) {
      this.setState({ quantity: this.state.quantity - 1 })
    }
  }

  increaseQuantity = (event) => {
    event.preventDefault()

    this.setState({ quantity: this.state.quantity + 1 })
  }

  handleSelectedPartsChanged = (configurationId, selectedPartIds) => {
    let configurations = this.state.chosenConfigurations
    configurations[configurationId].partIds = selectedPartIds

    this.setState({ chosenConfigurations: configurations })
  }

  getSpecialInstructions() {
    return this.state.specialInstruction
  }

  isServiceConfigurationsValid() {
    const configurations = this.state.chosenConfigurations

    for (let i = 0; i < this.props.serviceSectionPartConfigs.length; i++) {
      const config = this.props.serviceSectionPartConfigs[i]
      if (config.min > configurations[config.id].partIds.length) {
        return false
      }
    }
    return true
  }

  isAddToCartButtonEnabled() {
    return this.isServiceConfigurationsValid()
  }

  handleSpecialInstructionChanged = (event) => {
    this.setState({ specialInstruction: event.target.value })
  }

  isAGift = (service) => {
    return (
      service.name.toLowerCase().includes("biglietto") ||
      service.name.toLowerCase().includes("biglietti")
    )
  }

  render() {
    let image, additionalParts

    if (this.props.service) {
      image = this.props.service.image_url ? (
        <img className="service-image" src={this.props.service.image_url} />
      ) : (
        <div className={`service-image image-placeholder`} />
      )
    }

    if (
      this.props.serviceSectionPartConfigs &&
      this.props.serviceSectionPartConfigs.length > 0
    ) {
      additionalParts = (
        <div>
          <label style={{ marginTop: "10px" }}>
            {I18n.t("service_ordering.add_service_modal.choose_ingredients")}
          </label>
          <div className="service-parts-list">
            <ServiceConfigurator
              serviceSectionPartConfigs={this.props.serviceSectionPartConfigs}
              onSelectedPartsChanged={this.handleSelectedPartsChanged}
            />
          </div>
        </div>
      )
    }

    const { service } = this.props

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.props.onExited}
        className="modal modal--full-height add-service-modal"
        animation={true}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="body-inner-container">
            <div className="service-image-container">{image}</div>

            <div className="description-container">
              {service.brand && (
                <p className="brand mb-0">
                  {service.brand?.charAt(0).toUpperCase() +
                    service.brand?.toLowerCase().slice(1)}
                </p>
              )}
              <p className="name">{service.name}</p>
              <HumanizedPrice
                useFlex
                price_cents={service.price_cents}
                original_price_cents={service.original_price_cents}
              />
              {/* <p className="availability mt-3">
                {service.stock_quantity > 0
                  ? I18n.t("service_ordering.add_service_modal.available")
                  : I18n.t("service_ordering.add_service_modal.not_available")}
              </p> */}

              <div className="description">
                <p className="title">
                  {I18n.t("service_ordering.add_service_modal.description")}
                </p>
                <ShowMoreText
                  lines={5}
                  more={I18n.t("pages.venues.show.venue_details.show_more")}
                  less={I18n.t("pages.venues.show.venue_details.show_less")}
                  anchorClass="show-more"
                  expanded={false}
                  keepNewLines={true}
                >
                  {this.props.service.description}
                </ShowMoreText>
              </div>

              {additionalParts}

              {this.isAGift(service) && (
                <div className="description">
                  <p className="title">
                    {I18n.t(
                      "service_ordering.add_service_modal.special_instructions"
                    )}
                  </p>

                  <div className="special-instructions mb-5">
                    <textarea
                      placeholder={I18n.t(
                        "service_ordering.special_instructions"
                      )}
                      value={this.state.specialInstruction}
                      onChange={this.handleSpecialInstructionChanged}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="change-quantity-box">
            <a
              href="#"
              className="button decrease"
              title={I18n.t("service_ordering.decrease_quantity")}
              onClick={this.decreaseQuantity}
            >
              <span className="fal fa-minus icon" />
            </a>
            <span className="quantity">{this.state.quantity}</span>
            <a
              href="#"
              className="button increase"
              title={I18n.t("service_ordering.increase_quantity")}
              onClick={this.increaseQuantity}
            >
              <span className="fal fa-plus icon" />
            </a>
          </div>
          <AddServiceButton
            enabled={this.isAddToCartButtonEnabled()}
            onClick={this.addToCart}
          />
        </Modal.Footer>
      </Modal>
    )
  }
}
